export const SEARCH_FORM_SUBMIT = 'STAFF.QUESTIONS.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'STAFF.QUESTIONS.SORT_CHANGE';
export const PAGE_CHANGE = 'STAFF.QUESTIONS.PAGE_CHANGE';
export const FETCH_LIST = 'STAFF.QUESTIONS.FETCH_LIST';
export const FETCH_ONE = 'STAFF.QUESTION.FETCH_ONE';
export const CLEAR_ONE = 'STAFF.QUESTION.CLEAR_ONE';
